<div
  [innerHTML]="notification.Message"
  [class]="css"
  id="id-alert-message"
></div>
